import { render } from "./NavbarAside.vue?vue&type=template&id=b42e1544"
import script from "./NavbarAside.vue?vue&type=script&lang=js"
export * from "./NavbarAside.vue?vue&type=script&lang=js"

import exportComponent from "/srv/git/index-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__